import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {SearchSort} from "../../offer/list/constants/SearchSort";
import {OfferType} from "../../offer/types/OfferType";

interface IVendorDetailViewSliceState {
    activeOffersListParams: {
        page: number;
        region: number | null;
        count: number;
        offerType: OfferType | null;
        sort: SearchSort;
    };
    soldOffersListParams: {
        page: number;
    };
}

const initialState: IVendorDetailViewSliceState = {
    activeOffersListParams: {
        page: 1,
        region: null,
        count: 0,
        offerType: null,
        sort: SearchSort.DEFAULT
    },
    soldOffersListParams: {
        page: 1
    }
};

export const vendorDetailViewSlice = createSlice({
    name: "vendorDetailViewSlice",
    initialState,
    reducers: {
        initVendorDetailFilters: (
            state,
            action: PayloadAction<{
                region: number | null;
                offerType: OfferType | null;
            }>
        ) => {
            state.activeOffersListParams.region = action.payload.region;
            state.activeOffersListParams.offerType = action.payload.offerType;
            state.activeOffersListParams.page = 1;
        },
        setActiveOffersNextPage: (state) => {
            state.activeOffersListParams.page += 1;
        },
        setActiveOffersPage: (state, action: PayloadAction<number>) => {
            state.activeOffersListParams.page = action.payload;
        },
        setVendorActiveRegion: (state, action: PayloadAction<number | null>) => {
            state.activeOffersListParams.region = action.payload;
        },
        setVendorActiveOfferType: (state, action: PayloadAction<OfferType | null>) => {
            state.activeOffersListParams.offerType = action.payload;
        },
        setVendorActiveSort: (state, action: PayloadAction<SearchSort>) => {
            state.activeOffersListParams.sort = action.payload;
        },
        resetActiveOffersPage: (state) => {
            state.activeOffersListParams.page = 1;
        },
        resetActiveOfferType: (state) => {
            state.activeOffersListParams.offerType = null;
        },
        setSoldOffersNextPage: (state) => {
            state.soldOffersListParams.page += 1;
        },
        resetSoldOffersPage: (state) => {
            state.soldOffersListParams.page = 1;
        },
        setActiveOffersCount: (state, action: PayloadAction<number>) => {
            state.activeOffersListParams.count = action.payload;
        }
    }
});

export const {
    initVendorDetailFilters,
    setActiveOffersNextPage,
    setActiveOffersPage,
    setVendorActiveRegion,
    setVendorActiveOfferType,
    setVendorActiveSort,
    resetActiveOffersPage,
    resetActiveOfferType,
    setSoldOffersNextPage,
    resetSoldOffersPage,
    setActiveOffersCount
} = vendorDetailViewSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {SearchSort} from "../../offer/list/constants/SearchSort";
import {OfferType} from "../../offer/types/OfferType";

interface IVendorDetailViewSliceState {
    activeOffersListParams: {
        page: number;
        region: number | null;
        count: number;
        offerType: OfferType | null;
        sort: SearchSort;
    };
    soldOffersListParams: {
        page: number;
    };
}

const initialState: IVendorDetailViewSliceState = {
    activeOffersListParams: {
        page: 1,
        region: null,
        count: 0,
        offerType: null,
        sort: SearchSort.DEFAULT
    },
    soldOffersListParams: {
        page: 1
    }
};

export const vendorDetailViewSlice = createSlice({
    name: "vendorDetailViewSlice",
    initialState,
    reducers: {
        initVendorDetailFilters: (
            state,
            action: PayloadAction<{
                region: number | null;
                offerType: OfferType | null;
            }>
        ) => {
            state.activeOffersListParams.region = action.payload.region;
            state.activeOffersListParams.offerType = action.payload.offerType;
            state.activeOffersListParams.page = 1;
        },
        setActiveOffersNextPage: (state) => {
            state.activeOffersListParams.page += 1;
        },
        setActiveOffersPage: (state, action: PayloadAction<number>) => {
            state.activeOffersListParams.page = action.payload;
        },
        setVendorActiveRegion: (state, action: PayloadAction<number | null>) => {
            state.activeOffersListParams.region = action.payload;
        },
        setVendorActiveOfferType: (state, action: PayloadAction<OfferType | null>) => {
            state.activeOffersListParams.offerType = action.payload;
        },
        setVendorActiveSort: (state, action: PayloadAction<SearchSort>) => {
            state.activeOffersListParams.sort = action.payload;
        },
        resetActiveOffersPage: (state) => {
            state.activeOffersListParams.page = 1;
        },
        resetActiveOfferType: (state) => {
            state.activeOffersListParams.offerType = null;
        },
        setSoldOffersNextPage: (state) => {
            state.soldOffersListParams.page += 1;
        },
        resetSoldOffersPage: (state) => {
            state.soldOffersListParams.page = 1;
        },
        setActiveOffersCount: (state, action: PayloadAction<number>) => {
            state.activeOffersListParams.count = action.payload;
        }
    }
});

export const {
    initVendorDetailFilters,
    setActiveOffersNextPage,
    setActiveOffersPage,
    setVendorActiveRegion,
    setVendorActiveOfferType,
    setVendorActiveSort,
    resetActiveOffersPage,
    resetActiveOfferType,
    setSoldOffersNextPage,
    resetSoldOffersPage,
    setActiveOffersCount
} = vendorDetailViewSlice.actions;
